import React from 'react';
import styled from 'styled-components';
import type { IHeaderOrder } from './types';

const HeaderOrder: React.FC<IHeaderOrder> = (props) => {
  const { className = '', label = '', description = '' } = props;

  return (
    <StyledHeaderOrder className={className}>
      <StyledLabel>{label}</StyledLabel>
      <StyledDescription>{description}</StyledDescription>
    </StyledHeaderOrder>
  );
};

const StyledHeaderOrder = styled.div`
  border-radius: 3px;
  border: 1px solid #efefef;
  padding: 3px 10px;
  height: 45px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-around;
  margin: auto;
`;

const StyledLabel = styled.div`
  font-size: 13px;
  color: #efefef;
`;

const StyledDescription = styled.div`
  font-size: 10px;
  color: #efefef;
`;

export default HeaderOrder;
